import React from 'react';
import { Tab, Button, Header, Modal } from 'semantic-ui-react';
import OptionsList from '../systemAdmin/OptionsList';
import Option from '../systemAdmin/Option';
import { connect } from 'react-redux';
import { newProfileModal } from '../../redux/actions/modals'

class NewProfileModal extends React.Component {

  state = {
    changed: {}
  }

  onChange = (key, option, value) => {

    const newData = [...this.props.modal[key].map(x => x.code === option.code ? {...option} : x)];

    const data = {
      ...this.props.modal,
      [key]: newData
    }

    this.props.newProfileModal(true, data, data.onSave).then(() => this.setState({ changed: {...this.state.changed, [option.code]: Option.getValue(option)}}))
  }

  isValid = () => {

    let valid = true;

    const options = [...this.props.modal.cms, ...this.props.modal.cmsMobile, ...this.props.modal.header, ...this.props.modal.siteController]

    options.forEach(option => {
      if (option.isRequired && Option.getValue(option) === '') {
        valid = false
      }
    })

    return valid;
  }

  render() {

    const { open, cms, cmsMobile, siteController, header, onSave, isLoading } = this.props.modal
    const onClose = () => this.props.newProfileModal(false)

    const panes = [
      {
        menuItem: 'CMS',
        pane: <Tab.Pane><OptionsList options={cms} onChange={(option, value) => this.onChange('cms', option, value)} /></Tab.Pane>
      },
      {
        menuItem: 'CMS Mobile',
        pane: <Tab.Pane><OptionsList options={cmsMobile} onChange={(option, value) => this.onChange('cmsMobile', option, value)} /></Tab.Pane>
      },
      {
        menuItem: 'Site Controller',
        pane: <Tab.Pane><OptionsList options={siteController} onChange={(option, value) => this.onChange('siteController', option, value)} /></Tab.Pane>
      }
    ];

    return (
        <Modal
          open={open}
          onClose={onClose}
          closeIcon
          size="large"
        >
          <Header>New Profile</Header>
          <Modal.Content scrolling style={{ minHeight: "200px"}}>
            <OptionsList options={header} onChange={(option, value) => this.onChange('header', option, value)} />
            <Tab renderActiveOnly={false} panes={panes} />
          </Modal.Content>
          <Modal.Actions>
            <Button negative onClick={onClose}>Cancel</Button>
            <Button
              onClick={() => onSave(this.state.changed)}
              content="Save"
              labelPosition='right'
              loading={isLoading}
              disabled={!this.isValid()}
              icon='save'
              positive
            />
          </Modal.Actions>  
        </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    modal: state.newProfileModal,
    logIn: state.logIn
  }
}

export default connect(mapStateToProps, { newProfileModal })(NewProfileModal);